exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3cid2{padding-left:16px;padding-left:1rem;padding-right:16px;padding-right:1rem}@media screen and (min-width:768px){._3cid2{margin-left:auto;margin-right:auto;max-width:580px}}._2FGCv{list-style:none;padding-left:0;position:relative;z-index:1}._14Aod{margin-bottom:24px;margin-bottom:1.5rem}@media screen and (min-width:768px){._14Aod{margin-bottom:2rem}}", ""]);

// exports
exports.locals = {
	"container": "_3cid2",
	"newsList": "_2FGCv",
	"newsList__item": "_14Aod"
};